// extracted by mini-css-extract-plugin
export default {"loader-page":"LoaderPage_loader-page__ZUOKI"};